const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Whiterock",

  webfeedDebuggerWebsiteUrl:
    "https://mywhiterock.com.au/land-sales/#/masterplan",
  webfeedConfig: {
    mode: "masterplan", // masterplan, feed
    type: "land" // land, packages, dwellings etc
  }
  // add other conf items below if needed
};
